module.exports = __webpack_public_path__ + "static/media/NHS 10mm - RGB Blue on white.e837900a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/NHS 10mm - RGB Blue on white.jpg
// module id = 133
// module chunks = 0